module.exports = __webpack_public_path__ + "img/profile-jose.909497bd.webp";